import {
    TWO_FA_UPDATE_FLAGS_SUCCESS,
    TWO_FA_UPDATE_FLAGS_FAILED,
    LOADING_TWO_FA_UPDATE_FLAGS,
    RESET_TWO_FA_UPDATE_FLAGS,
    NETWORK_ERROR_TWO_FA_UPDATE_FLAGS,
} from "../types";

const initialState = {
    isLoading: false,
    failed: false,
    success: false,
    data: {},
    networkError: "",
    invalidRequest: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_TWO_FA_UPDATE_FLAGS: {
            return {
                ...state,
                isLoading: true,
                failed: false,
                success: false,
                invalidRequest: false,
                data: {},
            };
        }
        case TWO_FA_UPDATE_FLAGS_FAILED: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case TWO_FA_UPDATE_FLAGS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                failed: false,
                success: true,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case NETWORK_ERROR_TWO_FA_UPDATE_FLAGS: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                networkError: "Something went wrong. Check internet connection",
                data: {},
            };
        }
        case RESET_TWO_FA_UPDATE_FLAGS: {
            return (state = initialState);
        }

        default:
            return state;
    }
};
